import { delay } from 'redux-saga';
import { put, takeLatest, takeEvery, race, take } from 'redux-saga/effects';
import actionKey from '../utils/action-key';
import { GET_QUESTIONS } from './assessments';
import { GENERATE_PDF_REPORT } from './users';
import { FETCH_THEME } from './theme';

export const DISMISS_SNACKBAR = 'snackbars/DISMISS_SNACKBAR';
export const SHOW_SNACKBAR = 'snackbars/SHOW_SNACKBAR';


const actions = {
    [actionKey.failure(GET_QUESTIONS)]: {
        message: 'Error getting questions',
        type: 'failure',
        timeout: 5000,
    },
    [actionKey.failure(GENERATE_PDF_REPORT)]: {
        message: 'Error generating PDF',
        type: 'failure',
        timeout: 5000,
    },
    [actionKey.failure(FETCH_THEME)]: {
        message: 'Something went wrong',
        type: 'failure',
        timeout: 5000,
    },
};


export default function reducer(state = null, action) {
    switch (action.type) {
        case SHOW_SNACKBAR:
            return {
                ...action.payload,
            };
        case DISMISS_SNACKBAR:
            return null;
        default:
            return state;
    }
}


export const dismissAction = () => ({
    type: DISMISS_SNACKBAR,
});

export function* rootSaga() {
    yield [
        takeEvery(Object.keys(actions), showSnackbarSaga),
        takeLatest(SHOW_SNACKBAR, hideSnackbar),
    ];
}

function* showSnackbarSaga({ type }) {
    yield put(showSnackbarAction(actions[type]));
}

export const showSnackbarAction = payload => ({
    type: SHOW_SNACKBAR,
    payload,
});

function* hideSnackbar({ payload: { timeout } }) {
    if (!timeout) {
        return;
    }
    const { cancel } = yield race({
        pause: delay(timeout),
        cancel: take(DISMISS_SNACKBAR),
    });
    if (cancel) {
        return;
    }
    yield put({
        type: DISMISS_SNACKBAR,
    });
}



// WEBPACK FOOTER //
// ./src/client/redux/snackbar.js